import { useRef } from 'react'
import { useField } from 'formik'
import { Dropdown as DSDropdown } from '@machobear/design-system'
import useFocusOnError from '@/hooks/use-focus-on-error'

// isMulti is excluded from props.
// The prop is handled in SelectField.
// The prop needs to be added back in when the design is ready.

type DropDownProps = {
  name: string
  label: string
  required?: boolean
  onChange?: (v: string | undefined) => unknown
  options: { value: string; label: string; secondaryLabel?: string; tertiaryLabel?: string }[]
  disabled?: boolean
  onBlur?: () => unknown
  searchable?: boolean
}

export const Dropdown = (props: DropDownProps) => {
  const fieldRef = useRef()
  const [field, meta, helpers] = useField(props.name)
  const { setValue } = helpers

  useFocusOnError({ fieldRef, name: props.name })
  const onChangeWrapper = async (v: string | undefined) => {
    await props.onChange?.(v)
    await setValue(v, true)
  }

  return (
    <DSDropdown
      id={props.name}
      {...props}
      {...field}
      onChange={onChangeWrapper}
      isMulti={false}
      message={meta.error && meta.touched ? meta.error : undefined}
      tone={meta.error && meta.touched ? 'critical' : undefined}
      searchable={props.searchable}
    />
  )
}
